import { render, staticRenderFns } from "./compPoolSet.vue?vue&type=template&id=5f0fb5e3&scoped=true"
import script from "./compPoolSet.vue?vue&type=script&lang=js"
export * from "./compPoolSet.vue?vue&type=script&lang=js"
import style0 from "./compPoolSet.vue?vue&type=style&index=0&id=5f0fb5e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0fb5e3",
  null
  
)

export default component.exports